import React from 'react';

const LassSprechen = () => {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black text-white min-h-screen px-6 py-24">
      <div className="max-w-5xl mx-auto text-center space-y-16">
        {/* Başlık */}
        <div className="space-y-6">
          <h1 className="text-5xl md:text-6xl font-extrabold text-fuchsia-400">
            Lass uns gemeinsam digital durchstarten.
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Deine Vision verdient es, gesehen zu werden – ob Startup, Mittelstand oder Global Player.
            Wir helfen dir, digital sichtbar, nutzbar und erfolgreich zu werden. Mit Strategie, Design, Technologie – und echtem Teamgeist.
          </p>
        </div>

        {/* Neden Biz? */}
        <div className="grid md:grid-cols-3 gap-8 text-left text-sm text-gray-300">
          <div className="bg-white/5 p-6 rounded-xl border border-gray-700 hover:bg-white/10 transition">
            <h3 className="text-lg font-semibold text-white mb-2">💡 Individuelle Beratung</h3>
            <p>Wir hören zu, analysieren und denken mit – nicht nur um ein Projekt umzusetzen, sondern um dein Business wirklich zu stärken.</p>
          </div>
          <div className="bg-white/5 p-6 rounded-xl border border-gray-700 hover:bg-white/10 transition">
            <h3 className="text-lg font-semibold text-white mb-2">🚀 Schnelle Umsetzung</h3>
            <p>Agile Methoden, transparente Kommunikation und ein erfahrenes Team sorgen für zügige und saubere Ergebnisse.</p>
          </div>
          <div className="bg-white/5 p-6 rounded-xl border border-gray-700 hover:bg-white/10 transition">
            <h3 className="text-lg font-semibold text-white mb-2">📈 Langfristiger Erfolg</h3>
            <p>Ob Skalierung, SEO oder technischer Support – wir bleiben auch nach dem Launch an deiner Seite.</p>
          </div>
        </div>

        {/* CTA */}
        <div className="space-y-4">
          <h3 className="text-2xl font-bold text-white">Bereit, loszulegen?</h3>
          <a
            href="/angebot-form"
            className="inline-block no-underline bg-fuchsia-600 hover:bg-fuchsia-700 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg transition"
          >
            📨 Jetzt unverbindlich Angebot anfragen
          </a>
          <p className="text-gray-500 text-sm">
            Oder schreib uns direkt an <a href="mailto:kontakt@netmoove.de" className="text-fuchsia-400 underline">kontakt@netmoove.de</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LassSprechen;
